// extracted by mini-css-extract-plugin
export default {"cakeCard":"Cake_cakeCard__5r01U"};